import { useContext } from "react"
import TeamContext from "../../context/TeamContext"

function Card({children}) {
  const {team} = useContext(TeamContext)

  return (
    <div className={"bg-primary content-center p-12 rounded-xl shadow-xl content-between " + (team != 'select-team' ? team : '') + (team === '49ers' ? ' niners' : '')}>
      {children}
    </div>
  )
}

export default Card
